import React from "react";
import { Link } from "react-router-dom";
import "./VehicleCard.css";

export default function VehicleCard({ title, imageSrc, href = "#", background }) {
    return (
        <article
            className="vehicle-card"
            style={{
                background: background || "#121214"
            }}
        >
            <div className="vehicle-card__body">
                <h3 className="vehicle-card__title">{title}</h3>
                <div className="vehicle-card__media">
                    <img src={imageSrc} alt={title} className="vehicle-card__img" />
                </div>
                <div className="vehicle-card__link">
                    <Link to={href} >
                        Explore Now
                    </Link>
                </div>

            </div>
        </article>
    );
}

